


















import { Component, Vue } from 'vue-property-decorator';
import CartHeader from '@/components/Commons/Header.vue';
import CartFooter from '@/components/Commons/Footer.vue';
import UserStep from '@/components/Checkout/UserStep.vue';
import ShippingStep from '@/components/Checkout/ShippingStep.vue';
import InvoiceStep from '@/components/Checkout/InvoiceStep.vue';
import PaymentStep from '@/components/Checkout/PaymentStep.vue';
import CartSummary from '@/components/Checkout/CartSummary.vue';
import store from '@/store';
import { i18n } from '@/i18n';
import checkout from '@/store/modules/checkout';
import cart from '@/store/modules/cart';
import ui from '@/store/modules/ui';
import user from '@/store/modules/user';
import { CartItem as CartItemModel, Totals } from '@/store/models';
import gtmhelpers from '@/commons/gtmhelpers';

@Component({
  components: {
    CartHeader,
    CartFooter,
    UserStep,
    ShippingStep,
    InvoiceStep,
    PaymentStep,
    CartSummary,
  },
})
export default class Checkout extends Vue {

  private mounted() {
    const shippingAddress = checkout.shippingAddress;
    store.commit('removeWarningByType', 'shippingaddress_zipdigits');
    if (store.state.options.enabled_warnings.zipdigits
        && store.state.options.countrysettings.zipdigits
        && !store.getters.hasWarningsByType('shippingaddress_zipdigits')
        && shippingAddress.postcode
        && shippingAddress.postcode.length !== parseInt(store.state.options.countrysettings.zipdigits, 10)
    ) {
      store.commit('addWarning', {
        type: 'shippingaddress_zipdigits',
        message: i18n.t('zipdigitwarnings', { zipdigits: store.state.options.countrysettings.zipdigits }).toString(),
      });
    }
    checkout.initializeStepStatus();
  }

  get items(): CartItemModel[] {
    return cart.cart.items;
  }

  get canShip(): boolean {
    return !cart.cart.is_virtual;
  }

  get componentKeys(): Record<string, string> {
    return ui.componentKeys;
  }

  get isDevelop(): boolean {
    return (process.env.NODE_ENV === 'development') ? true : false;
  }

  get isLogged(): boolean {
    return user.isLoggedin;
  }

}
